import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { TranslationEnum } from 'src/app/shared/enums/translation-enum';
import { Proform } from 'src/app/shared/models/order-register/proforms-list/proform.model';
import { OrderRegisterService } from '../order-register.service';
import { Contractor } from 'src/app/shared/models/user/contractor.model';
import { Route } from 'src/app/shared/models/order-register/order-list/route.model';
import { DataSharingService } from 'src/app/shared/service/data-sharing.service';

@Component({
  selector: 'app-route-list',
  templateUrl: './route-list.component.html',
  styleUrls: ['./route-list.component.scss'],
    animations: [
      trigger('detailExpand', [
        state('collapsed', style({ height: '0px', minHeight: '0' })),
        state('expanded', style({ height: '*' })),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]),
    ],
})
export class RouteListComponent implements OnInit, AfterViewInit {
public TranslationEnum = TranslationEnum;


  dateFrom: string = null;
  dateTo: string = null;
  @Output() dateChange = new EventEmitter<{ value: string }>();

range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  contractorNumber: string;
  source: Route[] = [];
  search: string = '';
  constructor(private dataSharingService: DataSharingService, private orderRegisterService: OrderRegisterService) {
    const contractor = JSON.parse(sessionStorage.getItem('_slc')) as Contractor;
    this.contractorNumber = contractor.ContractorNumber;
  }
  ngAfterViewInit(): void {

    this.dataSharingService.contractorChanged.subscribe((x) => {
      if (x) {
        const contractor = JSON.parse(sessionStorage.getItem('_slc')) as Contractor;
        this.contractorNumber = contractor.ContractorNumber;
        this.Init();
      }
    });

    this.Init();
  }
  Init(){
    this.source = [];
  this.isLoadingResults = true;
  this.isRateLimitReached = false;
    this.orderRegisterService.getRoutes(this.contractorNumber).subscribe((data) => {
      console.log("Routes", data);
      this.source = data;
      this.source.forEach(element => {
        element.Departure_Date = new Date(element.Departure_Date);
      });
      this.Filter();
      this.isLoadingResults = false;
      }, (err) => {

          this.isRateLimitReached = true;
      });
  }

   columnsToDisplay: string[] = ['Route_Id', 'Departure_Date', 'Package_Number_Sum',  'Delivery_Time', 'Driver', 'Drivers_Phone_Number', 'Delivery_Address', 'Delivery_City', 'Delivery_Country', 'Sum_of_Weights'];
  
    expandDisplayedColumns: string[] = [
      'Order',
      'B2B_Number',
      'Package_Number', 'Sum_of_Weights', 'RefersTo'
    ];
    dataSource: MatTableDataSource<Route>;
    // data: Proform[] = [];
    expandedElement: Proform | null;
  
    resultsLength = 0;
    isLoadingResults = true;
    isRateLimitReached = false;
      
  ngOnInit(): void {
  }
  getDetails(Id:number){
    
    return this.source.filter(x =>x.Route_Id == Id);
  }
  Filter(){
    var f:Route[] = []; //.filter(x => x.B2B_Number.includes(this.search));
    var s = this.source;
    if(this.search != ''){
      s = s.filter(x =>  (x.B2B_Number == null && (x.Order.toLocaleUpperCase().includes(this.search) || x.Package_Number.toString().toLocaleUpperCase().includes(this.search) || x.Route_Id.toString().toLocaleUpperCase().includes(this.search) || x.RefersTo.toLocaleUpperCase().includes(this.search))) || (x.B2B_Number != null && (x.B2B_Number.toLocaleUpperCase().includes(this.search) || (x.Order.toLocaleUpperCase().includes(this.search) || x.Package_Number.toString().toLocaleUpperCase().includes(this.search) || x.Route_Id.toString().toLocaleUpperCase().includes(this.search) || x.RefersTo.toLocaleUpperCase().includes(this.search)) )));
    }
    if(this.dateFrom != null && this.dateTo != null){
      var dto = new Date(this.dateTo);
      var dfrom = new Date(this.dateFrom);
      console.log(this.dateTo, this.dateFrom, dto, dfrom);
      s = s.filter(x =>  x.Departure_Date >= dfrom && x.Departure_Date <= dto);
    }
    s.forEach(element => {
      var find = f.find(x => x.Route_Id == element.Route_Id);
      // console.log("f", find, element.Route_Id);
      if(find == null){
        element.Package_Number_Sum = element.Package_Number;
        f.push(element);
      } else {
        find.Package_Number_Sum += element.Package_Number;
      }
    });
    
    this.dataSource = new MatTableDataSource(f);
    
  }
   applyFilter(input: HTMLInputElement) {
    this.search = input.value.toLocaleUpperCase();
    this.Filter();
    //this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  getIlosc(Route_Id){
    var ilosc = 0;
    this.source.forEach(element => {
      if(element.Route_Id == Route_Id){
        ilosc+=element.Package_Number;
      }
    });
    return ilosc;
  }
  getWaga(Route_Id){
    var waga = 0.0;
    this.source.forEach(element => {
      if(element.Route_Id == Route_Id){
        waga+=element.Sum_of_Weights;
      }
    });
    return Math.round(waga*100)/100 ;
  }
  dateRangeChange(event: Event): void {
    if (this.range.controls['start'].value && this.range.controls['end'].value) {
      this.dateFrom = this.range.controls['start'].value.toISOString().slice(0, 10);
      this.dateTo = this.range.controls['end'].value.toISOString().slice(0, 10);
      this.Filter();
    }
  }

}
